var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2162 30.3505H3.70013C2.17801 30.3505 0.943359 29.25 0.943359 27.8934V12.8421C0.943359 11.4854 2.17801 10.385 3.70013 10.385H31.2162C32.7383 10.385 33.973 11.4854 33.973 12.8421V27.8934C33.973 29.25 32.7383 30.3505 31.2162 30.3505Z",
    fill: "#00AAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1176 5.66138H6.72684C5.45165 5.66138 4.41602 6.58443 4.41602 7.72099V9.33058H30.4284V7.72099C30.4284 6.58114 29.3928 5.66138 28.1176 5.66138Z",
    fill: "#FC592D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.647 0.888428H9.34598C8.07079 0.888428 7.03516 1.81148 7.03516 2.94804V4.55763H27.9615V2.94804C27.9579 1.81148 26.9259 0.888428 25.647 0.888428Z",
    fill: "#FFCE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductListIcon);
export default __webpack_public_path__ + "static/media/Product_list_icon.13f69e073cb2a92f9c09abb3c4ed37c9.svg";
export { ForwardRef as ReactComponent };